import MenuIconPath from "@ingka/ssr-icon/paths/menu";

export default MenuIconPath;
